import Elemento from './Elemento.js';

export default class Filtro extends Elemento {
  constructor() {
    super();
    this.valorSel = new String();
    this.valores = new Array();
    this.getValor = function (param) {
      var element = param == undefined ? (element = this.valorSel) : param;

      var filter = this.valores.find((valorEl) => valorEl.cod == element);

      return filter != undefined ? filter : this.valores[0];
    };
  }
}
